import * as React from 'react';
import { withRouter, Link, RouteComponentProps } from 'react-router-dom';
import { Col, Row, Divider } from 'antd';
import { Title } from '../../components/Layout/components';

interface INotFoundProps extends RouteComponentProps {
  domain: string;
  deliveryMethodId?: string;
}

class NotFoundPage extends React.Component<INotFoundProps> {

  public render() {
    return (
      <Row>
        <Col span={24} style={{ background: 'transparent', padding: '15% 0' }}>
          <Row>
            <Col span={24} style={{ textAlign: 'center' }}>
              <h2
                style={{
                  fontSize: '150pt',
                  lineHeight: '200px',
                  fontWeight: 'bold',
                  padding: '0',
                  margin: '0',
                  color: '#DDD'
                }}
              >
                404
              </h2>
              <h4 style={{ padding: '0', margin: '0', fontSize: '23px', fontWeight: 'bold', textTransform: 'uppercase' }}>Opps! This page could not be found!</h4>
              <div style={{ marginBottom: '20px', textTransform: 'uppercase' }}>Sorry but the page you are looking for does not exist</div>
              <Link to={`/${this.props.domain}/application/dashboard`} className="ant-btn ant-btn-primary">Back to home</Link>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default withRouter(NotFoundPage);



// WEBPACK FOOTER //
// ./src/scenes/NotFound/NotFound.tsx